import { render, staticRenderFns } from "./logisticsLogDetail.vue?vue&type=template&id=3cc1ddd8"
import script from "./logisticsLogDetail.vue?vue&type=script&lang=js"
export * from "./logisticsLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports